var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M8.4,7.6C8,7.6,7.6,8,7.6,8.4v10.5 c0,0.4,0.4,0.8,0.8,0.8h4.8l-0.7,1.7v0.2c0,0.1,0.1,0.1,0.2,0.1h5.2l0.2-0.1v-0.2l-0.7-1.7h4.8c0.4,0,0.8-0.4,0.8-0.8V8.4 c0-0.4-0.4-0.8-0.8-0.8H8.4z M22.6,19c0,0.2-0.1,0.3-0.3,0.3H8.4c-0.2,0-0.3-0.1-0.3-0.3v-0.1v-1.5h14.5V19z M22.6,16.9H8.1V8.4 c0-0.2,0.1-0.3,0.3-0.3h13.8h0.1c0.2,0,0.3,0.1,0.3,0.3V16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.4,8.1h-0.1H8.4c-0.2,0-0.3,0.1-0.3,0.3v8.3h14.5V8.4C22.6,8.3,22.5,8.1,22.4,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.1,17.4v1.5V19c0,0.2,0.1,0.3,0.3,0.3h13.9c0.2,0,0.3-0.1,0.3-0.3v-1.6H8.1z M9.4,18.1h1.1l0.2,0.2 c0,0.1-0.1,0.2-0.2,0.2H9.4c-0.1,0-0.2-0.1-0.2-0.2L9.4,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M31.7,35.3h4.8c0.4,0,0.8-0.4,0.8-0.8v-0.1 V24.1c0-0.4-0.4-0.8-0.8-0.8H22.7c-0.2,0-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.2,0.6v10.4v0.1c0,0.4,0.4,0.8,0.8,0.8h4.8l-0.7,1.7 v0.2h5.6v-0.2L31.7,35.3z M22.4,24.1v-0.1c0-0.2,0.1-0.3,0.3-0.3h13.8h0.1c0.2,0,0.3,0.1,0.3,0.3v8.6H22.4V24.1z M22.4,33.1h14.5 v1.5c0,0.2-0.1,0.3-0.3,0.3H22.7c-0.2,0-0.3-0.1-0.3-0.3v-0.1V33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.9,32.4v-8.4c0-0.2-0.1-0.3-0.3-0.3h-0.1H22.7c-0.2,0-0.3,0.1-0.3,0.3V24v8.3H36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.4,34.5c0,0.2,0.1,0.3,0.3,0.3h13.9c0.2,0,0.3-0.1,0.3-0.3v-1.5H22.4V34.5L22.4,34.5z M23.7,33.6h1.1 c0.2,0,0.3,0.1,0.3,0.3c0,0.1-0.1,0.2-0.3,0.2h-1.1c-0.1,0-0.2-0.1-0.2-0.2C23.6,33.8,23.6,33.6,23.7,33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M23.7,34.1h1.1c0.2,0,0.3-0.1,0.3-0.2c0-0.2-0.1-0.3-0.3-0.3h-1.1c-0.1,0-0.2,0.1-0.2,0.3 C23.6,34.1,23.6,34.1,23.7,34.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M12.1,32.8h5.1c0.2,0,0.3-0.1,0.3-0.2 c0-0.2-0.1-0.3-0.3-0.3h-4.8v-5.1l0.8,0.7c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0-0.1,0-0.1-0.1-0.2l-1.1-1.1v0 c-0.2-0.1-0.1-0.2-0.3-0.2c-0.1,0,0,0-0.2,0.2l-1.2,1.1c-0.1,0.1-0.1,0.2,0,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.2,0 c0.1,0,0.1-0.1,0.1-0.1c0.3-0.3,0.5-0.5,0.8-0.8v5.5C11.9,32.7,11.9,32.8,12.1,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M32.8,12.3h-5.1c-0.2,0-0.3,0.1-0.3,0.2 c0,0.2,0.1,0.3,0.3,0.3h4.8v5.1l-0.8-0.7c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.2l1.1,1.1v0 c0.2,0.1,0.1,0.2,0.3,0.2c0.1,0,0,0,0.2-0.2l1.2-1.1c0.1-0.1,0.1-0.2,0-0.3c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0 c-0.1,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.5,0.5-0.8,0.8v-5.5C33,12.4,32.9,12.3,32.8,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M9.4,18.6h1.1c0.2,0,0.3-0.1,0.3-0.2c0-0.2-0.1-0.3-0.3-0.3H9.4c-0.1,0-0.2,0.1-0.2,0.3 C9.2,18.6,9.3,18.6,9.4,18.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenShare);
export default __webpack_public_path__ + "static/media/screen_share.e9c005ac72178376cf2c5c232adaa9c2.svg";
export { ForwardRef as ReactComponent };